import { Injectable } from '@angular/core';
import { DataService } from "./data.service";
import { environment } from "src/environments/environment";
import { Observable, of, tap } from "rxjs";
import { Prompt } from "src/app/core/models/prompts.model";

@Injectable({
  providedIn: 'root'
})
export class PromptsService {
  private cachedPrompts: Prompt[] | null = null;

  constructor(
    private readonly _dataService: DataService
  ) {}

  get apiBaseUrl(): string {
    return environment.apiBaseUrl;
  }

  /**
   * Load prompts from API and store in cache. Call on app init or when refreshing.
   */
  loadPrompts(): Observable<Prompt[]> {
    const url = this.apiBaseUrl + "api/v1/prompts";
    return this._dataService.get(url).pipe(
      tap((prompts) => { this.cachedPrompts = prompts || []; })
    );
  }

  /**
   * Ensure prompts are loaded (from cache or API) and return them.
   */
  ensureLoaded(): Observable<Prompt[]> {
    if (this.cachedPrompts !== null) {
      return of(this.cachedPrompts);
    }
    return this.loadPrompts();
  }

  /**
   * Get a prompt by type (e.g. "Soap Note Validation"). Returns undefined if not in cache.
   */
  getPromptByType(type: string): Prompt | undefined {
    if (!this.cachedPrompts) return undefined;
    return this.cachedPrompts.find((p) => p.type === type);
  }

  updatePrompt(promptId: string, prompt: any): Observable<Prompt> {
    const url = this.apiBaseUrl + `api/v1/prompts/${promptId}`;
    return this._dataService.patch(url, prompt);
  }
}